import { render, staticRenderFns } from "./TaskManagerPolicyForm.vue?vue&type=template&id=f889bbb6"
import script from "./TaskManagerPolicyForm.vue?vue&type=script&lang=js"
export * from "./TaskManagerPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports